import { toast } from "react-toastify";
import { IUploadResponse } from "./models";
import {
    gselectedgroup,
    gingestioniteminfo,
    gloggedinuser,
    greindexparams
} from "../interfaces";
import {
    toastBaseOpt,
    statusIsOkArr,
    statusDemandsActionArr
} from "../lsts";
import {
    wait,
    logRespErr,
    toastFinOpt,
    toastFinErr,
    getDynamicEnd,
    inMsgConstruct,
    itterPositionOk,
    fetchTaskStatus,
    removeTaskIdFromLocal
} from "../util_glob";


// docs, local vid
export async function uploadDocs(
    request: FormData,
    loggedInUser: gloggedinuser,
    gid: string,
    refreshMe?: (fileids?:string, isfromchat?: boolean, gid?: string) => void,
    isvideofiles?: boolean,
    isfromchat?: boolean,
    splitinv?: number,
    cod?: string
): Promise<IUploadResponse> {

    let waitTime      = 4000
    const muffinToast = toast.loading("Uploading Files...", toastBaseOpt);
    let fin           = false;

    setTimeout(() => {
        if (!fin && refreshMe) refreshMe();
    }, 2000);

    let url = getDynamicEnd(isvideofiles); // determine endpoint between /upload & /upload_video
    import.meta.env.DEV && console.log("‹upload_url›", url);
    const resp = await fetch(url, {
        method: 'POST',
        headers: {
            "userid": loggedInUser.userId,
            "groupid": gid,
            "splitinv": (splitinv ?? 0).toString(),
            "cod": cod ?? ''
        },
        body: request
    });

    if (!resp.ok) logRespErr(resp);

    const data: any    = await resp.json();

    const tid          = data.task_id;

    let endWhile       = false;
    let isSuccessFinal = false;

    let uiMsg          = "";
    let lastMsg        = "-1";

    let loopCount      = 0;

    while (!endWhile) {
        loopCount++;
        await wait(waitTime);

        const tChk = await fetchTaskStatus(tid);

        if (statusDemandsActionArr.includes(tChk.status)) {
            // status is success or partial or error
            import.meta.env.DEV && console.log("‹end_001›", tChk);

            // status is success or partial
            isSuccessFinal = statusIsOkArr.includes(tChk.status)

            uiMsg    = tChk.message;
            endWhile = true;

            // finalize and close toast
            toast.update(muffinToast, toastFinOpt(tChk.message));

        } else {
            import.meta.env.DEV && console.log("‹loop_001›", tChk);

            if (tChk.filecount !== undefined) {
                uiMsg = inMsgConstruct(tChk);

                toast.update(muffinToast, {render: uiMsg});
            }

            if (itterPositionOk(loopCount, 40) && refreshMe) refreshMe(tChk?.files, isfromchat, gid);
        }

        if (lastMsg !== uiMsg && refreshMe) refreshMe(tChk?.files, isfromchat, gid);

        lastMsg = uiMsg;
    }
    removeTaskIdFromLocal(tid);

    const uplResponse: IUploadResponse = { success: isSuccessFinal, message: uiMsg };
    return uplResponse;
}



// main yt
export async function addUrlKgnf(
    urlString: string,
    selectedGroup: gselectedgroup,
    company: string,
    claimsUserId: string,
    cTy: string,
    itemInfo: gingestioniteminfo[],
    refreshMe?: (fileids?: string, isfromchat?: boolean, gid?: string) => void,
    webThrottlingActive?: boolean,
    isfromchat?: boolean
): Promise<IUploadResponse> {

    let waitTime = 4000

    let fin = false;
    let gid = selectedGroup.selectionId;

    setTimeout(() => {
        if (!fin && refreshMe) refreshMe();
    }, 2000);

    const resp = await fetch("/add_url", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            url: urlString,
            groupid: selectedGroup.selectionId,
            companyid: company,
            userId: claimsUserId,
            cty: cTy,
            sectionoverlap: selectedGroup.sectionoverlap,
            maxsectionlength: selectedGroup.maxsectionlength,
            sentencesearchlimit: selectedGroup.sentencesearchlimit,
            webthrottlingactive: webThrottlingActive,
            fileInfo: { ...itemInfo }
        })
    });

    if (!resp.ok) logRespErr(resp);

    const muffinToast = toast.loading("Processing Content...", toastBaseOpt);

    const data: any   = await resp.json();

    const tid         = data.task_id;

    let endWhile      = false;
    let taskRes       = false;

    let uiMsg         = "";
    let lastMsg       = "-1";

    let loopCount     = 0;

    while (!endWhile) {
        loopCount++;
        await wait(waitTime);
        const tChk   = await fetchTaskStatus(tid);

        if (statusDemandsActionArr.includes(tChk.status)) {
            // finalize
            taskRes  = statusIsOkArr.includes(tChk.status);
            uiMsg    = tChk.message;
            endWhile = true;

        } else {
            // loop more
            if (tChk.fileCount !== undefined) {
                uiMsg = tChk.message;

                if (uiMsg.toLowerCase().includes("error")) {
                    toast.update(muffinToast, { render: `${uiMsg}`, type: "error" });
                } else {
                    toast.update(muffinToast, { render: `${uiMsg}` });
                }
            }
            if (itterPositionOk(loopCount, 5) && refreshMe) refreshMe(tChk?.files, isfromchat, gid);
        }

        if (lastMsg !== uiMsg) if (refreshMe) refreshMe(tChk?.files, isfromchat, gid);

        lastMsg = uiMsg;
    }

    if (uiMsg.toLowerCase().includes("error")) {
        toast.update(muffinToast, toastFinErr(uiMsg));
    } else {
        toast.update(muffinToast, toastFinOpt(uiMsg));
    }

    const uplResponse: IUploadResponse = { success: taskRes, message: uiMsg };
    return uplResponse;
}


// reindex
export async function reprocessDocs(props: greindexparams, refreshMe?: (fileids?:string, isfromchat?: boolean, gid?: string) => void): Promise<IUploadResponse> {
    let waitTime = 4000

    const response = await fetch("/reindex_docs", {
        method: "POST",
        headers: props.header,
        body: JSON.stringify({
            filestring: props.fileString,
            userid: props.userId,
            companyid: props.company,
            groupid: props.selectedGroup.selectionId,
            sectionoverlap: props.selectedGroup.sectionoverlap,
            maxsectionlength: props.selectedGroup.maxsectionlength,
            sentencesearchlimit: props.selectedGroup.sentencesearchlimit,
            modstring: props.modString,
            idstring: props.idString,
            invoicesgroup: props.selectedGroup.invoicesgroup,
            assistanttype: props.selectedGroup.assistanttype,
            contenttype_config: props.selectedGroup.contenttype_config,
            enhance_img: props.selectedGroup.enhance_img,
            doc_page_len: props.doc_page_len
        })
    });

    if (!response.ok) console.log(`Reindexing Files Failed: ${response.statusText}`);

    const dataResponse: any = await response.json();

    const taskId            = dataResponse.task_id;

    let loopCount           = 0;

    let endWhile            = false;
    let taskRes             = false;

    let uiMsg               = "";
    let lastMsg             = "-1";

    const muffinToast       = toast.loading("Reprocessing Files...", toastBaseOpt);

    while (!endWhile) {
        loopCount++;

        await wait(waitTime);
        const tChk = await fetchTaskStatus(taskId);

        if (statusDemandsActionArr.includes(tChk.status)) {
            taskRes     = statusIsOkArr.includes(tChk.status)
            uiMsg       = tChk.message;

            endWhile    = true;
            toast.update(muffinToast, toastFinOpt(tChk.message));

        } else {

            if (tChk.fileCount !== undefined) {
                uiMsg =  inMsgConstruct(tChk)
                toast.update(muffinToast, {render: uiMsg});
            }

            if (itterPositionOk(loopCount, 5) && refreshMe) refreshMe();
        }

        if (lastMsg !== uiMsg && refreshMe) refreshMe();

        lastMsg = uiMsg;
    }

    const uplResponse: IUploadResponse = { success: taskRes, message: uiMsg };
    return uplResponse;
}
